/**
 *操作日志 vm
 *@author xujinjiang
 *@date 2022/3/1 17:38
 */

import { BaseViewModel } from '@/viewmodel/BaseViewModel';
import { AuditLogServiceImpl } from '@/service/AuditLogServiceImpl';
import { actionType } from '@/constant/ActionType';
import { CommonUtil } from '@/utils/CommonUtil';

export class LogViewModel extends BaseViewModel {
  totalCount = 0;
  loading: any;
  actionType = actionType;

  tableBodyEl: any;

  logList = [];
  tableHeight = window.innerHeight - 250;

  isShowNull = false;

  mounted() {
    this.loading = CommonUtil.loading('.el-table__body-wrapper');
    this.tableBodyEl = document.querySelector('.el-table__body-wrapper') as HTMLElement;
    if (this.tableBodyEl) {
      this.tableBodyEl.style.minHeight = '100px';
    }
    this.getAuditLogList(1, 20);
    window.addEventListener('resize', () => {
      this.tableHeight = window.innerHeight - 250;
    });
  }

  change($event: any) {
    this.loading = CommonUtil.loading('.el-table__body-wrapper');
    this.getAuditLogList($event.pageNo, $event.pageSize);
  }

  getAuditLogList(pageNo: number, pageSize: number) {
    AuditLogServiceImpl.getInstance()
      .getAuditLogList('', pageNo, pageSize)
      ?.then((res) => {
        this.logList = (res as any).result;
        this.totalCount = (res as any).totalCount;
        this.loading.close();
        this.tableBodyEl.style.minHeight = '0px';
        this.isShowNull = true;
      });
  }

  getActionType(type: string) {
    if (!type) {
      return '';
    }
    // @ts-ignore
    const obj = this.actionType[type];
    if (!obj) {
      console.debug(type, '没有该操作行为字段');
      return;
    }
    return obj.chineseTitle;
  }

  getAddress(data: any) {
    const address = CommonUtil.checkEmpetyProvince(data.province, data.city, data.area);
    return address;
  }
}
